/**
 * Shared scroll-reveal utility (design-spec.md §3/§8 custom-section register).
 * Any element with class="rv" fades + rises into view once, IntersectionObserver-driven,
 * with a 60ms stagger among siblings sharing the same parent. Gated behind
 * prefers-reduced-motion (reveals instantly, no motion). No section/JSON wiring needed
 * beyond adding the .rv class to markup — reused by any page/section that needs it.
 */
const reveal = (el) => {
  el.classList.add('rv--in');
};

if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
  document.querySelectorAll('.rv').forEach(reveal);
} else {
  // ponytail: stagger computed from DOM order among .rv siblings sharing a parent —
  // good enough for the flat lists (grids, carousels, tile bands) this targets.
  const siblingIndex = new Map();
  document.querySelectorAll('.rv').forEach((el) => {
    const list = siblingIndex.get(el.parentElement) || [];
    list.push(el);
    siblingIndex.set(el.parentElement, list);
  });

  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const el = entry.target;
        const siblings = siblingIndex.get(el.parentElement) || [el];
        const index = Math.max(siblings.indexOf(el), 0);
        el.style.transitionDelay = `${index * 60}ms`;
        reveal(el);
        obs.unobserve(el);
      });
    },
    { threshold: 0.15 }
  );

  document.querySelectorAll('.rv').forEach((el) => observer.observe(el));
}
